import { DraggableNode, LinkBetweenPorts } from '@components/graph';
import { Typography } from '@components/typography';
import { Box } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { CanvasContext } from './CanvasProvider';
import { GraphDataContext } from './GraphDataProvider';
import { ZoomContext } from './ZoomProvider';

export const GraphElements = () => {
  const [centered, setCentered] = useState(false);
  const { nodes, links, ready, graphMetadata } = useContext(GraphDataContext);
  const { centerGraphElements } = useContext(ZoomContext);

  const { svg } = useContext(CanvasContext);
  const { width: svgWidth, height: svgHeight } = svg?.node().getBoundingClientRect() || {
    width: 0,
    height: 0,
  };

  useEffect(() => {
    if (centered) {
      return;
    }
    if (ready) {
      centerGraphElements();
      setCentered(true);
    }
  }, [nodes, links, ready, centered, centerGraphElements]);

  const disabled = graphMetadata ? graphMetadata.readOnly : true;

  if (ready) {
    return (
      <>
        {(links || []).map(({ id, ...link }) => (
          <LinkBetweenPorts key={id} id={id} disabled={disabled} {...link} />
        ))}
        {(nodes || []).map((node, index) => (
          <DraggableNode key={node.name} index={index} disabled={disabled} {...node} />
        ))}
      </>
    );
  }

  return (
    <foreignObject
      height="100"
      width="100"
      transform={`translate(${0 + svgWidth / 2}, ${0 + svgHeight / 2})`}
    >
      <Box height={100} width={100}>
        <Typography data-cy="Graph-Elements-Loading">Loading...</Typography>
      </Box>
    </foreignObject>
  );
};
